import { Link } from "@/i18n/LangRouting";
import { ArrowLeft, LayoutGrid } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { fileUrl } from "@/lib/api";

export function Logo({ exhibition, sub }) {
  const { t } = useI18n();
  if (exhibition?.logo_url) return <img src={fileUrl(exhibition.logo_url)} alt={exhibition.name} className="h-7 object-contain" data-testid="header-logo" />;
  return (
    <span className="font-display uppercase leading-none" data-testid="header-logo">
      <span className="text-xl block">{exhibition?.name || t("site_name")}</span>
      <span className="block text-[0.6rem] tracking-[0.2em] text-[var(--muted)] font-sans mt-1">{sub || t("free_audio_guide")}</span>
    </span>
  );
}

export function LangButton() {
  const { lang, openLanguageSheet } = useI18n();
  return (
    <button type="button" onClick={openLanguageSheet} data-testid="header-lang-switcher" aria-label="Change language"
      className="border border-[var(--line)] px-3 py-1.5 text-xs font-bold tracking-widest uppercase hover:border-white transition-colors">
      {lang}
    </button>
  );
}

export function AllExhibitionsLink() {
  const { t } = useI18n();
  return (
    <Link to="/" data-testid="header-all-exhibitions" aria-label={t("all_exhibitions")} title={t("all_exhibitions")}
      className="border border-[var(--line)] px-3 py-1.5 text-xs font-bold tracking-widest uppercase hover:border-white transition-colors inline-flex items-center gap-2">
      <LayoutGrid size={14} /><span className="hidden sm:inline">{t("all_exhibitions")}</span>
    </Link>
  );
}

export default function Header({ back, label, exhibition, slug }) {
  return (
    <header className="flex items-center justify-between px-5 h-16 border-b border-[var(--line)] sticky top-0 z-30 backdrop-blur-md bg-[#111111]/85" data-testid="visitor-header">
      {back ? (
        <div className="flex items-center gap-3 min-w-0">
          <Link to={back} data-testid="header-back-button" aria-label="Back" className="ctrl -ml-3"><ArrowLeft size={22} /></Link>
          {label && <span className="text-xs tracking-[0.2em] uppercase text-[var(--muted)] truncate" data-testid="header-exhibition-label">{label}</span>}
        </div>
      ) : (slug ? <Link to={`/e/${slug}`} data-testid="header-logo-link"><Logo exhibition={exhibition} /></Link> : <Logo exhibition={exhibition} />)}
      <div className="flex items-center gap-2"><AllExhibitionsLink /><LangButton /></div>
    </header>
  );
}
